import WizardInput from 'componentes/wizard/WizardInput.js';
import { useAuth } from 'context/AuthProvider.js';
import { ApiEndpoint } from 'helpers/ApiEndPoint.js';
import { httpClient } from 'helpers/HttpClient.js';
import React, { useEffect, useState } from 'react';
import { Row } from 'react-bootstrap';
const URIConfig = ApiEndpoint + 'configuration/';
import PropTypes from 'prop-types';

const ConsumidorData = ({ register, errors }) => {
  const Auth = useAuth();
  var userData = Auth.getSessionData();
  const [generos, setGeneros] = useState(null);
  const getGeneros = async () => {
    setGeneros(null);

    httpClient('GET', URIConfig + 'statusbytype/' + 8, {}, userData.token)
      .then(function (response) {
        if (!response.data.error) {
          var customersList = response.data.map(item => {
            return { value: item.idstatus, label: item.descripcion };
          });
          setGeneros(customersList);
        }
      })
      .catch(function (error) {
        console.log(error);
      });
  };

  useEffect(() => {
    if (!generos) getGeneros();
  }, []);

  return (
    <>
      <Row className="g-2 mb-3">
        <WizardInput
          label="Nombre"
          name="nombre"
          errors={errors}
          formGroupProps={{ className: 'mb-3' }}
          formControlProps={{
            ...register('nombre', { required: true })
          }}
        />
      </Row>{' '}
      <Row className="g-2 mb-3">
        <WizardInput
          label="Telefono"
          name="telefono"
          type="inputmask"
          mask="999-999-9999"
          errors={errors}
          formGroupProps={{ className: 'mb-3' }}
          formControlProps={{
            ...register('telefono')
          }}
        />
      </Row>
      <Row className="g-2 mb-3">
        <WizardInput
          label="Email"
          name="email"
          type="text"
          errors={errors}
          formGroupProps={{ className: 'mb-3' }}
          formControlProps={{
            ...register('email', {
              required: 'El correo es obligatorio',
              pattern: {
                value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
                message: 'Correo inválido'
              }
            })
          }}
        />
      </Row>
      <Row className="g-2 mb-3">
        {generos && (
          <WizardInput
            label="Genero"
            type="select"
            name="genero"
            errors={errors}
            options={generos}
            formGroupProps={{ className: 'mb-3' }}
            formControlProps={{
              ...register('genero', { required: true })
            }}
          />
        )}
      </Row>
    </>
  );
};

ConsumidorData.propTypes = {
  register: PropTypes.func.isRequired,
  errors: PropTypes.object
};
export default ConsumidorData;
